var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartlyCloudyLightRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    id: "icon-partlycloudylightrain",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4,11.6c0.3,0,0.5,0.1,0.5,0.3v2.5c0,0.2-0.2,0.3-0.5,0.3s-0.5-0.1-0.5-0.3v-2.5C5.8,11.7,6.1,11.6,6.4,11.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.8,3.6c0.2,0.2,0.6,0.2,0.8,0c0.2-0.2,0.2-0.6,0-0.8L5.8,2C5.6,1.7,5.2,1.7,5,2S4.8,2.5,5,2.8L5.8,3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8,2.2c0.3,0,0.6-0.2,0.6-0.6V0.6c0-0.3-0.2-0.6-0.6-0.6S9.2,0.2,9.2,0.6v1.1C9.2,2,9.5,2.2,9.8,2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9,6.2h-1.1c-0.3,0-0.6,0.2-0.6,0.6s0.3,0.6,0.6,0.6h1.1c0.3,0,0.6-0.2,0.6-0.6S16.3,6.2,15.9,6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,2c-0.2-0.2-0.6-0.2-0.8,0l-0.8,0.8c-0.2,0.2-0.2,0.6,0,0.8c0.2,0.2,0.6,0.2,0.8,0l0.8-0.8C14.8,2.5,14.8,2.2,14.5,2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1,6.7c0-1.9-1.5-3.4-3.4-3.4c-1.1,0-2,0.5-2.7,1.3C6.7,4.5,6.3,4.5,5.9,4.5c-2.5,0-4.5,2-4.5,4.5c0,2.3,1.8,4.2,4,4.4             v-1.1C3.8,12.1,2.5,10.7,2.5,9c0-1.9,1.5-3.4,3.4-3.4c1.6,0,2.9,1.1,3.3,2.6C9.5,8,9.9,7.8,10.3,7.8c1.2,0,2.2,1,2.2,2.2             c0,1.2-1,2.2-2.2,2.2c-0.5,0-1.7,0-2.8,0v1.1c1.1,0,2.3,0,2.8,0c1.9,0,3.4-1.5,3.4-3.4c0-0.8-0.3-1.6-0.8-2.2             C13.1,7.5,13.1,7.1,13.1,6.7z M12,7.1c-0.5-0.3-1-0.4-1.6-0.4c-0.2,0-0.4,0-0.6,0.1C9.4,6.1,8.9,5.5,8.2,5.1c0.4-0.4,1-0.7,1.6-0.7             c1.2,0,2.2,1,2.2,2.2C12,6.9,12,7,12,7.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartlyCloudyLightRain);
export default __webpack_public_path__ + "static/media/partlyCloudyLightRain.2a55e7066051dba6d1eb5c1d26067669.svg";
export { ForwardRef as ReactComponent };